import styled from '@emotion/styled';
import {motion} from 'framer-motion';

const Container = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9001;
    top: 0;
    left: 0;
`
const Dim = styled(motion.div)`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .035);
`

const Spinner = styled.div`
    width: 40px;
    height: 40px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
`

const Cube = styled.div`
    background-color: white;
    border-radius: 2px;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    animation: sk-cubemove 1.8s infinite ease-in-out;

    @keyframes sk-cubemove {
        25% {
            transform: translateX(48px) rotate(-90deg) scale(0.6);
        }
        50% {
            transform: translateX(48px) translateY(48px) rotate(-179deg);
        }
        50.1% {
            transform: translateX(48px) translateY(48px) rotate(-180deg);
        }
        75% {
            transform: translateX(0px) translateY(48px) rotate(-270deg) scale(0.6);
        }
        100% {
            transform: rotate(-360deg);
        }
    }
`

export default function Loading() {
    return (
        <Container>
            <Dim/>
            <Spinner>
                <Cube/>
                <Cube style={{animationDelay: '-0.9s'}}/>
            </Spinner>
        </Container>
    );
}